export default __webpack_public_path__ + "static/media/desayuno.e12d4cfe.png";